import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import ModalDownloadApp from '../../Modals/ModalDownloadApp/ModalDownloadApp';
import getMobileDeviceInfo from '../../Utils/isMobileDevice';
import {
  shouldShowDownloadAppPopup,
  markDownloadAppPopupDismissed
} from '../../Utils/downloadAppPopupStorage';

function DownloadAppPopup() {
  const user = useSelector((state) => state.auth.user);
  const { trackEvent } = useMatomo();
  const [show, setShow] = useState(false);
  const hasEvaluated = useRef(false);

  useEffect(() => {
    if (!user || hasEvaluated.current) {
      return;
    }
    hasEvaluated.current = true;

    const { isMobile } = getMobileDeviceInfo();
    if (isMobile && shouldShowDownloadAppPopup()) {
      setShow(true);
      trackEvent({ category: 'MobileAppPopup', action: 'mobile_app_popup_displayed' });
    }
  }, [user, trackEvent]);

  const handleClose = () => {
    setShow(false);
    markDownloadAppPopupDismissed();
    trackEvent({ category: 'MobileAppPopup', action: 'mobile_app_popup_closed' });
  };

  const handleDownloadClick = () => {
    markDownloadAppPopupDismissed();
    trackEvent({ category: 'MobileAppPopup', action: 'mobile_app_download_clicked' });
  };

  if (!show) {
    return null;
  }

  const { isIOS } = getMobileDeviceInfo();

  return (
    <ModalDownloadApp
      show={show}
      isIOS={isIOS}
      onClose={handleClose}
      onDownloadClick={handleDownloadClick}
    />
  );
}

export default DownloadAppPopup;
